<template lang="pug">
  #Header
    //─── Barra superior oscura ──────────────────────────────────────────────
    div(class='topbar')
      div(class='topbar-inner')
        span(class='topbar-msg') Repuestos automotrices · Entregas inmediatas y seguras
        div(v-if='!email' class='topbar-actions')
          v-btn(text small class='topbar-btn' to='/ingreso').elevation-0
            v-icon(small left) person_outline
            | Ingresar
          span(class='topbar-sep')
          v-btn(text small class='topbar-btn' to='/registrarse').elevation-0 Registrarse
        div(v-if='email' class='topbar-actions')
          v-menu(key='Custom' offset-y='' style='z-index: 10000;')
            template(v-slot:activator='{ attrs, on }')
              v-btn(text small class='topbar-btn' v-bind='attrs' v-on='on').elevation-0
                v-icon(small left) account_circle
                | {{ email }}
                v-icon(small right) expand_more
            v-list(class='user-menu')
              v-list-item(v-for='item in items2' :key='item.title' link='' @click='seleccion(item)')
                v-list-item-title(v-text='item.title')
    //─── Barra principal ────────────────────────────────────────────────────
    header(class='mainbar')
      div(class='mainbar-inner')
        img(src='@/assets/imgFerco/logo2.png' class='imgLogo' @click='irHome()')
        div(class='search-wrap' v-click-outside='handleClickOutside')
          v-text-field(ref='inpSearch' @focus='handleClickInside()' v-model="searchText" color='grey' @keyup="handleSearchProduct($event)" :loading='(isLoading) ? "primary" : false' placeholder='¿Qué estás buscando?' single-line='' outlined='' hide-details='' dense='' class='search-input')
          v-btn(class='btnBuscar' @click='irProductos()').elevation-0
            v-icon(small left) search
            | Buscar
          v-list(v-if='isSearching' class='busq')
            v-list-item-group(v-if='searchResults && searchResults.length > 0' style='max-height: 290px;overflow-y: auto;')
              v-list-item(v-for='(item, i) in searchResults' :key='i' @click='irDetalle(item._id)' class='busq-item')
                v-layout(wrap)
                  v-flex(xs2 style='display: flex;justify-content: center;align-items: center;')
                    img(v-if='item.imagen' :src='ruta + item.imagen.url' style='width: auto;height: 48px;object-fit: contain;border-radius:8px;')
                    img(v-else src='@/assets/imgFerco/image.png' style='width: auto;height: 48px;object-fit: contain;')
                  v-flex(xs10 style='display: flex;flex-direction: column;justify-content: center;padding-left:8px;')
                    span(style='font-size:13px;font-weight:600;') {{item.art_des}}
                    div(v-if='!item.stock || item.stock <= 0' style='margin:3px 0;')
                      span(class='badge-nostock') Sin stock
                    div(v-if='mostrarS && item.stock && item.stock > 0' style='margin:2px 0;')
                      span(class='badge-stock') Existencia: {{item.stock}}
                    span(v-if='mostrarP' class='price-tag' style='font-size:13px;') ${{transform(item.precio)}}
            div(v-if='policeRes' style='display: flex;justify-content: center;padding: 24px;font-size: 15px;color:#8a8f98;')
              span No se han conseguido resultados.
            div(v-if='!policeRes && searchResults && searchResults.length > 0' style='display: flex;justify-content: center;padding: 12px;font-size: 14px;')
              a(@click='irProductos()' style='color:#c70000;font-weight:600;') Ver todos los resultados
        div(class='cart-wrap')
          button(@click='mostrarC = !mostrarC' class='cart-btn')
            div(v-if='car && car.length > 0' class='divCar')
              span {{car.length}}
            img(src='@/assets/imgFerco/carrito.png' class='cart-icon')
          div(v-if='mostrarC' class='divDetailCar')
            div(class='divDetailTitle')
              span Carrito de compra
              v-btn(@click='mostrarC = false' icon small style='background:transparent;').elevation-0
                img(src='@/assets/imgFerco/x.png' style='height:14px;width:14px;object-fit:contain;filter: brightness(0%);')
            div(class='cart-items')
              div(v-for='item in car' class='cart-item')
                v-flex(xs12)
                  v-layout(wrap)
                    v-flex(xs3 style='display: flex;justify-content: center;align-items: center;')
                      div(style='display: flex;justify-content: center;align-items: center;position: relative;width: 90%;')
                        img(v-if='item.imagen && item.imagen[0]' :src='ruta + item.imagen[0].url' style='height:64px;width:100%;object-fit:contain;border-radius:8px;')
                        img(v-else src='@/assets/imgFerco/image.png' style='width: auto;height: 48px;object-fit: contain;')
                    v-flex(xs7 style='padding-left:8px;')
                      span(style='font-size: 13px;font-weight: 600;line-height:1.3;') {{item.art_des}}
                      div(style='display:flex;padding-top:5px;align-items:center;')
                        span(class='price-tag' style='font-size: 14px;') ${{transform(item.precio)}}
                        span(style='margin-left:6px;font-size: 12px;color:#8a8f98;') × {{item.cant}}
                    v-flex(xs2 style='display: flex;justify-content: center;align-items: center;')
                      v-btn(@click='borrar(item)' icon small)
                        img(src='@/assets/imgFerco/basura.png' style='height:18px;width:18px;object-fit:contain;')
              div(v-if='!car || car.length == 0' class='cart-empty')
                img(src='@/assets/imgFerco/no hay articulos.png' style='height:130px;width:100%;object-fit:contain;')
                span(style='margin-top: 16px;font-weight: 600;color:#4b5058;') ¡No has añadido productos aún!
            div(style='display: flex;flex-direction: column;gap:8px;')
              v-btn(v-if='car && car.length > 0' @click='irCarrito()' class='btn-brand' style='height:42px;').elevation-0 Ver carrito
              v-btn(@click='irProduc()' class='btn-ghost' style='height:42px;').elevation-0 Ver productos

</template>
<script>
import { server, port, serverImg } from '@/services/environment'
import vClickOutside from 'v-click-outside'
import { EventBus } from '../Events.js'
import Api from '@/services/methods'
export default {
  directives: {
    clickOutside: vClickOutside.directive
  },
  data () {
    return {
      sheet: false,
      mostrarC: false,
      selector: 0,
      settings: {},
      car: [],
      count: 0,
      mostrarP: false,
      mostrarS: false,
      isLoading: false,
      isSearching: false,
      policeRes: false,
      searchResults: [],
      searchText: '',
      email: '',
      ruta: serverImg,
      items2: [],
      badge: 0
    }
  },
  watch: {
    searchText (val) {
      if (!val) {
        this.cont = 0
        this.isLoading = false
        this.policeRes = false
        this.isSearching = false
        this.searchResults = []
      }
    }
  },
  created () {
    if (this.$store.state.carEmanuel !== null) {
      this.car = this.$store.state.carEmanuel
    }
    if (this.$store.state.emanuelWeb && this.$store.state.emanuelWeb._id) {
      this.items2 = [
        {
          title: 'Perfil'
        },
        {
          title: 'Historial de facturas'
        },
        {
          title: 'Historial de pedidos'
        },
        {
          title: 'Mundial'
        },
        {
          title: 'Cerrar Sesión'
        }
      ]
    }
    if (this.$store.state.emanuelWeb && this.$store.state.emanuelWeb.co_cli) {
      this.mostrarP = true
      this.email = this.$store.state.emanuelWeb.email
    }
    if (this.$store.state.emanuelWeb && this.$store.state.emanuelWeb.stock) {
      this.mostrarS = this.$store.state.emanuelWeb.stock
    }
  },
  mounted () {
    EventBus.$on('vaciar', data => {
      this.car = this.$store.state.carEmanuel
    })
    EventBus.$on('limpiarSearch', data => {
      this.cont = 0
      this.isLoading = false
      this.policeRes = false
      this.isSearching = false
      this.searchResults = []
      this.searchText = ''
    })
    EventBus.$on('actCarrito', data => {
      if (this.$store.state.carEmanuel !== null) {
        this.car = this.$store.state.carEmanuel
      }
    })
  },
  methods: {
    transform (value) {
      value = parseFloat(value).toFixed(2)
      const val = value.toString().split('.')
      if (val.length > 1) {
        return (
          val[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') +
          ',' +
          val[1].slice(0, 2)
        )
      }
      return val[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
    },
    borrar (item) {
      this.$store.dispatch('eliminar', item)
      this.car = this.$store.state.car
    },
    irHome () {
      this.$router.push('/')
    },
    irCarrito () {
      this.$router.push('/carrito')
    },
    irDetalle (item) {
      if (this.$route.name == 'Detalle') {
        if (this.$route.params.id === item) {
          EventBus.$emit('buscarDetalle', item)
        } else {
          this.$router.push('/detalle/' + item).catch(() => {})
          EventBus.$emit('buscarDetalle', item)
        }
      } else {
        this.$router.push('/detalle/' + item).catch(() => {})
      }
    },
    irProduc () {
      this.$router.push({ name: 'Productos' })
    },
    irProductos () {
      if (this.$route.name == 'Productos') {
        EventBus.$emit('buscarProducto', this.searchText)
      } else {
        this.$router.push({ name: 'Productos', params: { value: this.searchText } })
      }
    },
    async handleSearchProduct (item) {
      if (item.key == 'Enter') {
        if (this.searchText) {
          this.$refs.inpSearch.blur()
          this.handleClickOutside()
          this.irProductos()
        }
      } else {
        this.policeRes = false
        this.count++
        const contador = this.count

        if (this.searchText !== '') {
          setTimeout(
            async function (cont) {
              if (cont == this.count) {
                this.isLoading = true
                const cli = (this.$store.state.emanuelWeb && this.$store.state.emanuelWeb.co_precio) ? this.$store.state.emanuelWeb.co_precio.trim() : null
                Api.get('productosCom/searchWeb?data=' + this.searchText + '&codigo=' + cli).then(res => {
                  if (res.data) {
                    setTimeout(
                      function () {
                        this.searchResults = res.data
                        if (!this.searchResults || this.searchResults.length == 0) this.policeRes = true
                        this.isLoading = false
                        this.isSearching = true
                      }.bind(this),
                      500
                    )
                  }
                  if (res.data && res.data[0]) {
                    this.settings = res.data[0]
                  }
                })
              }
            }.bind(this),
            800,
            contador
          )
        }
      }
    },
    handleClickInside () {
      if (this.searchText && this.searchResults && this.searchResults.length > 0) {
        this.isSearching = true
      }
    },
    handleClickOutside () {
      this.isSearching = false
      this.policeRes = false
      this.isLoading = false
    },
    seleccion (item) {
      if (item.title === 'Cerrar Sesión') {
        this.$store.dispatch('logout')
        window.location.href = '/'
      }
      if (item.title === 'Ingresar') {
        window.location.href = '/ingreso'
      }
      if (item.title === 'Perfil') {
        window.location.href = '/perfil'
      }
      if (item.title === 'Historial de pedidos') {
        window.location.href = '/historial'
      }
      if (item.title === 'Historial de facturas') {
        window.location.href = '/facturas'
      }
      if (item.title === 'Mundial') {
        window.location.href = '/mundial'
      }
    },
    revisar () {
      if (this.$store.state.emanuelWeb && this.$store.state.emanuelWeb._id) {
        this.$router.push('/transaccion')
      } else {
        this.$router.push('/ingreso')
      }
    },
    ir () {
      this.$router.push('/buscar')
    },
    vercarrito () {
      this.$router.push('/carrito')
    },
    logout () {
      this.$store.dispatch('logout')
      window.location.href = '/'
    },
    seleccion (item) {
      if (item.title === 'Cerrar Sesión') {
        this.$store.dispatch('logout')
        window.location.href = '/'
      }
      if (item.title === 'Ingresar') {
        window.location.href = '/ingreso'
      }
      if (item.title === 'Perfil') {
        window.location.href = '/perfil'
      }
      if (item.title === 'Historial de pedidos') {
        window.location.href = '/historial'
      }
      if (item.title === 'Historial de facturas') {
        window.location.href = '/facturas'
      }
      if (item.title === 'Mundial') {
        window.location.href = '/mundial'
      }
    },
    initialize () {
      Api.get('settings').then(res => {
        if (res.data && res.data[0]) {
          this.settings = res.data[0]
        }
      })
    },
    borrar (item) {
      this.$store.dispatch('eliminar', item)
      this.car = this.$store.state.carEmanuel
    }
  }
}
</script>
<style lang="scss">
@import "~@/assets/scss/header.scss";
.divDetailTitle {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 8px;
  border-bottom: 1px solid grey;
}
.divCar {
  height: 40px;
  width: 40px;
  background: #c70000;
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  position: absolute;
  right: 10px;
  top: 5px;
  z-index: 100000;
}
.ps-form--quick-search {
  .ps-form__input {
    position: relative;
    width: 100%;
    .v-progress-circular {
      // @include vertical-align();
      right: 10px;
      z-index: 20;
    }
    *::-webkit-input-placeholder {
      /* Google Chrome y Safari */
      color: #ffffff;
      font-style: italic;
    }
    *:-moz-placeholder {
      /* Firefox anterior a 19 */
      color: #ffffff;
      font-style: italic;
    }
    *::-moz-placeholder {
      /* Firefox 19 y superior */
      color: #ffffff;
      font-style: italic;
    }
    *:-ms-input-placeholder {
      /* Internet Explorer 10 y superior */
      color: #ffffff;
      font-style: italic;
    }
  }
}
</style>
